import React, { useState, useEffect, useRef } from "react";
import { Link, Redirect } from "react-router-dom";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Collapse, Modal } from "@material-ui/core";
import { Helmet } from "react-helmet";
import * as d3 from "d3";
import { event as currentEvent } from "d3";
import $, { isEmptyObject } from "jquery";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client'
import "./powerbi.scss";
export const LosstrackView = (props) => {
	
	const resultsDataItems = props.resultsData;
  	if(!resultsDataItems.token) {
    		return null;
  	}
	
	
 
return (
    <>
	<Helmet>
				<title>PowerBI | SmarterChains</title>
				<meta name="description" content="PowerBI" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/#">{resultsDataItems.title}</BreadcrumbsItem>
           <div id="pbi_embed0120">
			<PowerBIEmbed
					embedConfig = {{
						type: 'report',   // Supported types: report, dashboard, tile, visual and qna
						id: resultsDataItems.report_id, 
						embedUrl: resultsDataItems.embedUrl,
						accessToken: resultsDataItems.token
					}}
			  />
			</div>
			
    </>
  );
};
